import Button from "components/button"
import Input from "components/input"
import type React from "react"
import { useState } from "react"
import { toast } from "react-toastify"
import request from "request"
import type users from "../users"
import styles from "./create-modal.module.scss"

type ValidationError = {
  name: "email"
  value: string
} | null

interface UpdateUser {
  email?: string
}

const UpdateEmailModal = ({
  onClose,
  onEdit,
  selectedUser,
}: {
  selectedUser?: users.user
  onClose: () => void
  onEdit: () => void
}) => {
  const [email, setEmail] = useState(selectedUser?.email ?? "")
  const [pending, setPending] = useState(false)
  const [validError, setValidError] = useState<ValidationError>(null)

  const blocked = email === selectedUser?.email

  const handleEdit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (email.trim().length < 5) {
      return setValidError({
        name: "email",
        value: "Minimum email length 5 characters",
      })
    }
    if (!email.includes("@")) {
      return setValidError({
        name: "email",
        value: "Invalid email format",
      })
    }
    setValidError(null)

    setPending(true)

    const body: UpdateUser = { email: email.toLowerCase() }

    request
      .put("/admin/users/" + selectedUser?.id, body)
      .then(() => onEdit())
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.detail ||
          error.detail ||
          "An unknown error occurred."
        toast.error(`Error editing user email: ${errorMessage}`)
      })
      .finally(() => setPending(false))
  }

  return (
    <div className={styles.modal} onMouseDown={onClose}>
      <form
        onSubmit={handleEdit}
        className={styles.modalWrap}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className={styles.title}>Edit email</div>
        <div className={styles.inputs}>
          <div className={styles.input}>
            <Input
              title="Email"
              type="string"
              value={email}
              onInput={(value) => setEmail(value)}
            />
            {validError?.name === "email" && (
              <div className={styles.inputError}>{validError.value}</div>
            )}
          </div>
        </div>

        <div className={styles.buttonGroup}>
          <Button color="orange" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            color="green"
            pending={pending}
            blocked={blocked}
          >
            Edit
          </Button>
        </div>
      </form>
    </div>
  )
}

export default UpdateEmailModal
